import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FaRegEyeSlash } from 'react-icons/fa';
export function EmptyDataRow(props) {
    const { columns, text } = props;
    return (_jsx("tr", { children: _jsxs("td", { colSpan: columns.length, style: { textAlign: 'center', padding: '0.5em' }, children: [_jsx(FaRegEyeSlash, { style: {
                        display: 'inline-block',
                        margin: '0px 10px',
                        fontSize: '1.5em',
                        color: '#6a6a6a',
                    } }), _jsx("span", { style: { fontSize: '1.1em' }, children: text })] }) }));
}
